import axiosInstance from "../../../../Shared/Utils/axiosInstance";
import { PoliticSpaceApi } from "../../../../Shared/Constants/api";
import { getPoliticSpaceCreationObject } from "../Data/PoliticSpaceWrappers";

export const createPoliticSpaceApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${PoliticSpaceApi}`,
      getPoliticSpaceCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
